import React from 'react';
import { useTypedSelector } from '../../../redux';
import { SnackBar } from '../SnackBar';

/**
 * The event component lists to events created in the event reducer and display snack bars with the event information.
 */
export const Event = () => {
    const { event } = useTypedSelector(state => ({ event: state.event }));

    return (
        <>
            {Object.values(event).map(event => (
                <SnackBar
                    key={event.id}
                    severity={event.type}
                    snackbarProps={{
                        autoHideDuration: event.timeout * 1000,
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    }}
                >
                    {event.message}
                </SnackBar>
            ))}
        </>
    );
};
